import { useState } from "react";
import { http, track, inr, errText } from "../../lib/api";
import { Reveal } from "../Reveal";

export function Track() {
  const [ref, setRef] = useState("");
  const [mobile, setMobile] = useState("");
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const check = async () => {
    setBusy(true); setErr(""); setRes(null);
    try {
      const { data } = await http.post("/status", { reference: ref.trim(), mobile: "+91" + mobile.replace(/\D/g, "").slice(-10) });
      setRes(data);
      track("status_checked", { found: true });
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErr(d === "not_found" ? "We couldn't find that. Check the reference and the mobile number you used."
        : d === "rate_limited" ? "Too many checks. Please try again later." : errText(d));
      track("status_checked", { found: false });
    } finally { setBusy(false); }
  };

  const field = "w-full min-h-[44px] rounded-2xl border-2 border-[#e1e2e5] px-4 py-2.5 font-medium focus:border-[#004040] outline-none bg-white";

  return (
    <section id="track" className="py-16 md:py-24">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 grid lg:grid-cols-2 gap-10 items-start">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.2em] font-extrabold text-[#f06400]">Already applied?</p>
          <h2 className="mt-2 text-3xl md:text-4xl font-extrabold tracking-[-0.035em]">Track your application.</h2>
          <p className="mt-4 text-[#191c1f]/75 max-w-md">Enter your reference and the mobile number you used. We show exactly where you are.</p>
          <div className="mt-5 grid gap-3 max-w-md">
            <input className={field} placeholder="Reference, e.g. BLC-2026-000001" value={ref}
              onChange={(e) => setRef(e.target.value)} data-testid="track-application-input" aria-label="Reference" />
            <div className="flex items-center rounded-2xl border-2 border-[#e1e2e5] focus-within:border-[#004040] overflow-hidden">
              <span className="px-3 text-[#6b6f76] font-bold">+91</span>
              <input className="flex-1 min-h-[44px] px-2 outline-none" inputMode="numeric" maxLength={10}
                placeholder="Mobile used" value={mobile} data-testid="track-mobile"
                onChange={(e) => setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))} aria-label="Mobile" />
            </div>
            <button className="min-h-[48px] rounded-full bg-[#191c1f] hover:bg-black text-white font-bold disabled:opacity-60"
              onClick={check} disabled={busy || !ref || mobile.length < 10} data-testid="track-application-submit">
              {busy ? "Checking…" : "Check status"}
            </button>
            {err && <p className="text-sm text-[#8a2412] font-bold" data-testid="track-error">{err}</p>}
          </div>
        </Reveal>

        <Reveal delay={100}>
          <div className="rounded-[28px] border border-[#e1e2e5] p-6 md:p-8 bg-[#f4f5f6]" data-testid="track-result">
            {!res && <p className="text-[#6b6f76]">Your status timeline will appear here.</p>}
            {res && (
              <>
                {res.outcome ? (
                  <div className="rounded-2xl bg-[#fff0e6] p-4 mb-4 font-bold">{res.outcome_label}</div>
                ) : null}
                <ol className="space-y-3">
                  {res.stages.map((s, i) => {
                    const done = i <= res.stage_index;
                    return (
                      <li key={s} className="flex items-center gap-3">
                        <span className={`w-7 h-7 shrink-0 rounded-full grid place-items-center text-sm font-extrabold ${done ? "bg-[#004040] text-white" : "bg-white border border-[#e1e2e5] text-[#6b6f76]"}`}>
                          {done ? "✓" : i + 1}
                        </span>
                        <span className={`font-bold ${i === res.stage_index ? "text-[#191c1f]" : done ? "text-[#004040]" : "text-[#6b6f76]"}`}>{s}</span>
                      </li>
                    );
                  })}
                </ol>
                <p className="mt-4 text-sm text-[#6b6f76]">{res.note}</p>
              </>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
